module.exports = __webpack_public_path__ + "static/icon_life_saving_gift_process_04@2x-e7ce8d408d4add32f0ef5e40cdf1b379.png";